import { render, staticRenderFns } from "./departmentsummary.vue?vue&type=template&id=dcdce34a&scoped=true"
import script from "./departmentsummary.vue?vue&type=script&lang=js"
export * from "./departmentsummary.vue?vue&type=script&lang=js"
import style0 from "./departmentsummary.vue?vue&type=style&index=0&id=dcdce34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdce34a",
  null
  
)

export default component.exports